import { unwrapResult } from '@reduxjs/toolkit';

import type { AppDispatch } from '@/core/store/store';

import { exportAnalysisPdf } from '@/features/ChatBot/store';

export function getPdfFileNameFromTitle(title: string): string {
  return `${title.replace(/[^a-z0-9]+/gi, '-')}.pdf`;
}

export async function downloadAnalysisPdf(
  dispatch: AppDispatch,
  analysisId: number,
  fileName: string
): Promise<void> {
  const data = unwrapResult(await dispatch(exportAnalysisPdf(analysisId)));
  const url = URL.createObjectURL(data);
  const link = document.createElement('a');

  link.href = url;
  link.download = fileName;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
}
